import React from 'react';

function Footer() {
    return (
    <footer>
        <p>&copy; 2023 #Presstitute. All rights reserved.</p>
    </footer>
    );
}

export default Footer;
